import { useEffect } from "react";

// Título de la pestaña del navegador por sección (antes siempre era el mismo).
export function usePageTitle(title: string) {
  useEffect(() => {
    const prev = document.title;
    document.title = `${title} · Armony Contigo`;
    return () => { document.title = prev; };
  }, [title]);
}
